import { convertibleQuoteStatuses } from '../../constants/convertibleQuoteStatuses'
import { QuoteInvoiceState } from '../../enums/quoteInvoiceState'
import { QuoteStatus } from '../../enums/quoteStatus'
import type { QuoteConvertEligibilityData } from '../../types/quotes/quoteConvertEligibilityData'

export interface QuoteConvertEligibility {
  canShowConvertActions: boolean
  canConvertToRegularInvoice: boolean
  canCreateDepositInvoice: boolean
  isQuotePartiallyInvoiced: boolean
}

const canCreateDepositInvoice = (
  invoiceState: QuoteInvoiceState | undefined,
  quoteStatus: QuoteStatus | undefined,
): boolean => {
  if (invoiceState === undefined || quoteStatus === undefined) {
    return false
  }
  return invoiceState === QuoteInvoiceState.NotInvoiced && convertibleQuoteStatuses.includes(quoteStatus)
}

export const getQuoteConvertEligibility = (
  convertEligibilityData: QuoteConvertEligibilityData,
): QuoteConvertEligibility => {
  const { quoteStatus, invoiceState } = convertEligibilityData

  return {
    canShowConvertActions: quoteStatus !== undefined && quoteStatus !== QuoteStatus.Rejected,
    canConvertToRegularInvoice: quoteStatus !== undefined && convertibleQuoteStatuses.includes(quoteStatus),
    canCreateDepositInvoice: canCreateDepositInvoice(invoiceState, quoteStatus),
    isQuotePartiallyInvoiced: invoiceState === QuoteInvoiceState.PartiallyInvoiced,
  }
}
